var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoundedlogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 43 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#3f523a;}.cls-2{fill:#333;}.cls-3{fill:#e6e6e6;}.cls-4{fill:#ffbd2b;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M4.12,0h6.88V40H3.94c-2.18,0-3.94-1.77-3.94-3.94V4.12C0,1.85,1.85,0,4.12,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32,0h8.23c1.53,0,2.77,1.24,2.77,2.77V36.27c0,2.06-1.67,3.73-3.73,3.73h-7.27V0h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16,
    y: 13,
    width: 11,
    height: 27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 16,
    width: 11,
    height: 11
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundedlogo);
export default __webpack_public_path__ + "static/media/roundedlogo.e6c356cd84b3f88236b45852e1306f10.svg";
export { ForwardRef as ReactComponent };